module.exports = __webpack_public_path__ + "media/images/vp/icon.chevrondown-e9ea785c84754d1653dec7c3d86a1d87.svg";